import type { MutableRefObject } from 'react';

export const calculateTooltipPostion = (
  left: number,
  top: number,
  bottom: number,
  blockWidth: number,
  tooltipRef: MutableRefObject<any>,
) => {
  const { width: tooltipWidth, height: tooltipheight } =
    // @ts-ignore
    tooltipRef.current.getBoundingClientRect();
  const arrowGap = 6;
  const calculatedTop = top - tooltipheight - arrowGap;
  /**
   * Left Calculation Formula:
   * half of outside part = (tooltip width - block width) / 2
   * left = block left - half of outside part
   */
  const outsideHalfPart = (tooltipWidth - blockWidth) / 2;
  const calculatedLeft = left - outsideHalfPart;

  return { left: calculatedLeft, top: calculatedTop };
};
